import { render, staticRenderFns } from "./ChangePassword.vue?vue&type=template&id=87ce149c&"
import script from "./ChangePassword.vue?vue&type=script&lang=js&"
export * from "./ChangePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87ce149c')) {
      api.createRecord('87ce149c', component.options)
    } else {
      api.reload('87ce149c', component.options)
    }
    module.hot.accept("./ChangePassword.vue?vue&type=template&id=87ce149c&", function () {
      api.rerender('87ce149c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Email/Accounts/Modals/ChangePassword.vue"
export default component.exports